import { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { parse } from 'query-string'
import 'react-circular-progressbar/dist/styles.css'

import { Step1 } from './steps'
import { setLoanApplication, setPartnerDetails, setPersonData, setSubStep } from './redux/actions'
import axios from 'axios'
import { Spinner } from 'react-bootstrap-v5'
import { getIntegrationURLFromENV, handleSettingEnv } from '../../../utils/getIntegrationURLFromENV'
import './CoApplicant.scss'
import CoApplicantKYBComplete from './CoApplicantCompletekyb'
import { useLazyQuery } from '@apollo/client'
import query from '../../../setup/graphql/query'
import { fetchStop } from '../../../redux/actions/common'

const CoApplicantKYB: FC<any> = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const params: any = useParams()

  const { id } = params
  // const id = history.location.pathname.split('/')[2];
  const searchQuery: any = parse(history.location.search)

  const loanApplication = useSelector((state: any) => state.loan.loanApplication)
  const subStep = useSelector((state: any) => state.coApplicant.subStep)
  const [getApplication, onSuccessGetApplication] = useLazyQuery(query.GET_APPLICATION, {
    fetchPolicy: 'network-only', // always go to server
  })

  useEffect(() => {
    if (onSuccessGetApplication.data && !onSuccessGetApplication.error) {
      const { getLatestApplication } = onSuccessGetApplication.data
      dispatch(fetchStop())
      dispatch(setLoanApplication(getLatestApplication))
      if (getLatestApplication?.agentCode) {
        localStorage.setItem('agentCode', getLatestApplication?.agentCode)
      }
      if (['stage', 'sandbox', 'dev', 'local'].includes(localStorage.getItem('env') as string)) {
        ;(async () => {
          if (getLatestApplication && getLatestApplication.companyUEN) {
            const response = await import(
              `../../../utils/custom/${getLatestApplication?.companyUEN}/step3.json`
            )
            const eligibilityData: any = response.default
            if (eligibilityData) {
              // Dispatch the action to update the loan eligibility in the Redux store
              dispatch(setPersonData(eligibilityData))
            }
          }
        })()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSuccessGetApplication.data, onSuccessGetApplication.error, onSuccessGetApplication.loading])

  const [loading, setLoading] = useState(false)
  const partnerId = localStorage.getItem('partnerId')

  useEffect(() => {
    if (loanApplication == null) {
      getApplication({
        variables: {
          appId: id,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    // Run navigation and partner/env logic after loanApplication is available
    // if (!loanApplication) return

    let subStep = Number(searchQuery.subStep)

    if (subStep === 1 || isNaN(subStep)) {
      history.push(`/co-applicant-kyb/${id}`)
    }
    if (subStep !== 1 && !isNaN(subStep)) {
      dispatch(setSubStep(subStep))
      history.push(`/co-applicant-kyb/${id}?subStep=${subStep}`)
    }

    if (searchQuery?.partner || partnerId) {
      document.title = 'B2B PayLater KYB - Application'
      getPartnerDetails(searchQuery?.partner || partnerId)
    }

    handleSettingEnv(searchQuery?.env)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getPartnerDetails = async (partnerId: string) => {
    setLoading(true)

    const env = localStorage.getItem('env')
    const API_URL = getIntegrationURLFromENV(searchQuery?.env || env)

    const partnerData = await axios.get(`${API_URL}ext/api/businesspartner/${partnerId || ''}`)

    if (partnerData.data && partnerData.status === 200) {
      localStorage.setItem('partnerId', partnerData.data?.id)
      dispatch(setPartnerDetails(partnerData.data))
      setLoading(false)
    }
  }

  return (
    <>
      {loading ? (
        <div
          style={{ height: '100vh' }}
          className='d-flex justify-content-center align-items-center'
        >
          <Spinner
            style={{
              height: '5.35rem',
              width: '5.35rem',
            }}
            animation='grow'
            variant='danger'
          />
        </div>
      ) : (
        <div className='container my-0'>
          <div className='d-flex flex--center flex-column flex-column-fluid'>
            <div className='current' data-kt-stepper-element='content'>
              {subStep < 4 && <Step1 />}
              {subStep === 4 && <CoApplicantKYBComplete />}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default CoApplicantKYB
